import React from 'react';
import * as Styles from './Faq.styles';
import { Accordion } from 'gatorcomponents';

const Faq = ({
  marketingLocale,
  accordionItem,
  accordionsOpened,
  setAccordionsOpened,
}) => (
  <Styles.Row $paddingBottom>
    <Styles.Column>
      <Styles.FaqTitle>
        {marketingLocale.adsHandler.secondRow.title}
      </Styles.FaqTitle>
    </Styles.Column>

    <Styles.Column>
      <Styles.FaqItemsWrapper>
        {marketingLocale.adsHandler.secondRow.faqItems.map((item, index) => (
          <React.Fragment key={item.title}>
            <Accordion
              title={item.title}
              width="full"
              withIcon={false}
              actions={null}
              subtitle={false}
              withShadow={false}
              withBorder
              items={() => accordionItem({ item })}
              open={index === accordionsOpened}
              onToggleAccordion={() => setAccordionsOpened(index)}
            />
          </React.Fragment>
        ))}
      </Styles.FaqItemsWrapper>
    </Styles.Column>
  </Styles.Row>
);

export default Faq;
